import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input, model } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { ProductType } from "../../../../../helpers/enums/productType";
import { subscriptionNameKey } from "../../../../../helpers/subscription-i18n";
import { SubscriptionItem } from "../../malfunction-filter";

const FILTER_ALL_KEYS: Record<string, string> = {
  IP: "Malfunction.Filter.All.IP",
  LightPath: "Malfunction.Filter.All.LightPath",
  L2VPN: "Malfunction.Filter.All.L2VPN",
  L3VPN: "Malfunction.Filter.All.L3VPN",
  FW: "Malfunction.Filter.All.FW",
  // Firewall: legacy alias of FW that arrives via preset links.
  Firewall: "Malfunction.Filter.All.Firewall",
  Port: "Malfunction.Filter.All.Port",
};

@Component({
  selector: "malfunction-filter-service",
  templateUrl: "malfunction-filter-service.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, FormsModule, TranslatePipe],
})
export class MalfunctionFilterService {
  productType = model.required<string>();
  subscription = model.required<SubscriptionItem | undefined>();
  subscriptionList = input.required<Record<string, SubscriptionItem[]>>();
  productTypes = input.required<ProductType[]>();

  protected readonly subscriptions = computed(() => this.subscriptionList()[this.productType()] ?? []);
  protected readonly visibleProductTypes = computed(() =>
    this.productTypes()
      .filter((type) => !!this.subscriptionList()[type]?.length)
      .map((type) => ({ value: type, labelKey: subscriptionNameKey(type) ?? type })),
  );
  protected readonly allSubscriptionsLabelKey = computed(() => FILTER_ALL_KEYS[this.productType()] ?? "");
}
